module.exports = __webpack_public_path__ + "img/banner.cfbc8034.png";